import { render, staticRenderFns } from "./PurchaseSuccessModal.vue?vue&type=template&id=23b3099c&"
import script from "./PurchaseSuccessModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseSuccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports